/**
 * Chuyển chuỗi HTML (mô tả sách soạn bằng rich text editor) về plain text
 * để hiển thị trong danh sách/tooltip hoặc để tìm kiếm.
 *
 * Dùng DOMParser thay vì gán innerHTML: nội dung được parse trong một document
 * rời, nên ảnh/script trong chuỗi không bị tải hay chạy.
 */
// Các thẻ ngắt dòng: cần thêm khoảng trắng để "<p>A</p><p>B</p>" không thành "AB"
const BLOCK_TAGS = 'p,div,br,li,tr,h1,h2,h3,h4,h5,h6,blockquote';

export function stripHtml(html?: string | null): string {
  if (!html) return '';
  // Không có thẻ hay entity nào -> khỏi parse
  if (!/[<&]/.test(html)) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.body.querySelectorAll(BLOCK_TAGS).forEach((el) => el.after(' '));
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
}
